import axiosClient from "api/axiosClient"
import { IterationsPage, IterationWithResults } from "type/mapping/iteration"
import { WithStrId } from "type/withId"

export type IterationsPageParams = {
  search?: string
  type?: string
  status?: string
  limit: number
  offset: number
}

// История сопоставлений: поиск, фильтры и пагинация — на бэке
export const getIterationsPage = async (
  params: IterationsPageParams,
): Promise<IterationsPage> => {
  const { data } = await axiosClient.get("/mapping/result/iterations", { params })
  return data
}

export const getMappingIterationById = async (
  iterationId: string,
): Promise<WithStrId<IterationWithResults>> => {
  const { data: iteration } = await axiosClient.get(
    `/mapping/result/iteration/${iterationId}`,
  )
  return iteration
}
